export default __webpack_public_path__ + "static/media/no-connection.bb20e1d0.svg";